import { configure } from 'mobx';
import CommonStore from './common/commonStore';
import DashboardStore from './dashboard';
import MessageStore from './message/message';
import ProcareStore from './procare';
import RequestRepairStore from './requestRepair';
import AccountStore from '@store/account/accountStore';
import ShareStore from './common/shareStore';
import RequestStore from './request';
import CreateWOStore from '@store/requestRepair/createWOStore';
import CreateProcareStore from '@store/createProcare';
import UserProfile from '@store/userProfile';
import NewCreateRequestStore from '@store/newCreateRequest';
import TrainingResourceStore from './trainingResource/trainingResource';
import EmailToScheduleStore from './emailToSchedule';
import ProposedTimeForWOStore from './proposedTimeForWO';
import WoRatingStore from './woRating/woRatingStore';
import ResidentEmailToSchedule from "@store/emailToSchedule/ResidentEmailToSchedule";
import AppointmentDetailsStore from './appointmentDetails';
import SuperintendentBookingStore from './superintendentBooking';
configure({ enforceActions: 'observed' });
var Store = /** @class */ (function () {
    function Store() {
        this.commonStore = new CommonStore();
        this.dashboardStore = new DashboardStore();
        this.messageStore = new MessageStore();
        this.procareStore = new ProcareStore();
        this.requestRepairStore = new RequestRepairStore();
        this.accountStore = new AccountStore();
        this.shareStore = new ShareStore();
        this.requestStore = new RequestStore();
        this.createWOStore = new CreateWOStore();
        this.createProcareStore = new CreateProcareStore();
        this.userProfileStore = new UserProfile();
        this.trainingResourceStore = new TrainingResourceStore();
        this.emailToScheduleStore = new EmailToScheduleStore();
        this.residentEmailToSchedule = new ResidentEmailToSchedule();
        this.newCreateRequestStore = new NewCreateRequestStore();
        this.proposedTimeForWOStore = new ProposedTimeForWOStore();
        this.woRatingStore = new WoRatingStore();
        this.appointmentDetailsStore = new AppointmentDetailsStore();
        this.superintendentBookingStore = new SuperintendentBookingStore();
    }
    return Store;
}());
export { Store };
export default new Store();
